// animation
import { Fade } from "react-awesome-reveal";
// import icons
import { LadyLogo } from "utils/Icons";

const StepThree = ({ setActiveStep }) => {
  return (
    <>
      <div className="step_card_body">
        <Fade triggerOnce delay={200} duration={1000}>
          <LadyLogo className="mx_auto" />
        </Fade>
        <br />
        <Fade triggerOnce delay={400} duration={1200}>
          <h3>Now, it's YOUR turn. </h3>
        </Fade>
        <br />
        <Fade triggerOnce delay={1100} duration={1500}>
          <p>
            Your transformation to becoming a calmer, happier mom and raising
            happier kids begins TODAY.
            <br />
            <br />
            And it's easier than you think...
            <br />
            <br />
            Ready?
          </p>
        </Fade>
      </div>

      <div className="mt_auto screen_sticky_footer">
        <Fade triggerOnce delay={1400} duration={1300}>
          <button onClick={() => setActiveStep(3)} className="cs_btn w_100">
            Continue
          </button>
        </Fade>
      </div>
    </>
  );
};

export default StepThree;
